import { render, staticRenderFns } from "./H6Button.vue?vue&type=template&id=64b2c120&"
import script from "./H6Button.vue?vue&type=script&lang=js&"
export * from "./H6Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports